import React from 'react';
import { Mountain, Mail, Phone, MapPin, Facebook, Instagram, Youtube, ExternalLink } from 'lucide-react';
const partners = [{
  name: 'UIAA',
  fullName: 'International Climbing and Mountaineering Federation',
  url: 'https://www.theuiaa.org/'
}, {
  name: 'IFSC',
  fullName: 'International Federation of Sport Climbing',
  url: 'https://www.ifsc-climbing.org/'
}, {
  name: 'ISMF',
  fullName: 'International Ski Mountaineering Federation',
  url: 'https://www.ismf-ski.org/'
}, {
  name: 'НОК України',
  fullName: 'Національний олімпійський комітет України',
  url: 'https://noc-ukr.org/'
}, {
  name: 'МСМУ',
  fullName: 'Міністерство молоді та спорту України',
  url: 'https://sport.gov.ua/'
}];
export function Footer() {
  return <footer id="footer" className="bg-primary text-white border-t border-white/5" data-id="element-135">
      {/* Official Partners */}
      <div className="border-b border-white/10" data-id="element-136">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-137">
          <h3 className="text-xs font-bold text-white/50 uppercase tracking-wider text-center mb-5" data-id="element-138">
            Офіційні партнери федерації
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-3" data-id="element-139">
            {partners.map(partner => <a key={partner.name} href={partner.url} target="_blank" rel="noopener noreferrer" title={partner.fullName} className="group flex items-center space-x-1.5 text-white/50 hover:text-white transition-colors" data-id="element-140">
                <span className="text-sm font-semibold tracking-wide" data-id="element-141">
                  {partner.name}
                </span>
                <ExternalLink className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-142" />
              </a>)}
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="pt-8 pb-6" data-id="element-143">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-145">
            {/* Column 1: Logo & Info */}
            <div className="space-y-4" data-id="element-146">
              <div className="flex items-center space-x-2" data-id="element-147">
                <img src="https://cdn.magicpatterns.com/uploads/76VtWMo7xiaKkHHD54aMRj/logo-removebg-preview.png" alt="ФАіСУ" className="h-8 w-8 object-contain" data-id="element-148" />
                <span className="text-xl font-heading font-bold" data-id="element-149">ФАіСУ</span>
              </div>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-150">
                Всеукраїнська громадська організація "Федерація альпінізму і
                скелелазіння України". Розвиваємо горизонти можливого з 1991
                року.
              </p>
            </div>

            {/* Column 2: Quick Links */}
            <div data-id="element-151">
              <h3 className="text-sm font-bold mb-4 text-white uppercase tracking-wider border-b border-white/10 pb-2 inline-block" data-id="element-152">
                Навігація
              </h3>
              <ul className="space-y-1.5" data-id="element-153">
                {[{
                name: 'Головна',
                href: '/'
              }, {
                name: 'Федерація',
                href: '/federation'
              }, {
                name: 'Новини',
                href: '/news'
              }, {
                name: 'Календар подій',
                href: '/calendar'
              }, {
                name: 'Янголи',
                href: '/angels'
              }, {
                name: 'Документи',
                href: '/federation/documents'
              }].map(item => <li key={item.name} data-id="element-154">
                    <a href={item.href} className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-155">
                      {item.name}
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Column 3: Activities */}
            <div data-id="element-156">
              <h3 className="text-sm font-bold mb-4 text-white uppercase tracking-wider border-b border-white/10 pb-2 inline-block" data-id="element-157">
                Напрямки
              </h3>
              <ul className="space-y-1.5" data-id="element-158">
                {[{
                name: 'Альпінізм',
                href: '/alpinism'
              }, {
                name: 'Скелелазіння',
                href: '/climbing'
              }, {
                name: 'Льодолазіння',
                href: '#'
              }, {
                name: 'Скі-альпінізм',
                href: '#'
              }, {
                name: 'Скайраннінг',
                href: '#'
              }, {
                name: 'Школа інструкторів',
                href: '#'
              }].map(item => <li key={item.name} data-id="element-159">
                    <a href={item.href} className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-160">
                      {item.name}
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Column 4: Contacts */}
            <div data-id="element-161">
              <h3 className="text-sm font-bold mb-4 text-white uppercase tracking-wider border-b border-white/10 pb-2 inline-block" data-id="element-162">
                Контакти
              </h3>
              <ul className="space-y-3 mb-4" data-id="element-163">
                <li className="flex items-start space-x-3" data-id="element-164">
                  <MapPin className="h-4 w-4 text-white/40 mt-0.5 flex-shrink-0" data-id="element-165" />
                  <span className="text-white/60 text-sm" data-id="element-166">
                    01601, м. Київ,
                    <br data-id="element-167" />
                    вул. Еспланадна 42
                  </span>
                </li>
                <li className="flex items-center space-x-3" data-id="element-168">
                  <Phone className="h-4 w-4 text-white/40 flex-shrink-0" data-id="element-169" />
                  <span className="text-white/60 text-sm" data-id="element-170">
                    +38 (044) 289-12-34
                  </span>
                </li>
                <li className="flex items-center space-x-3" data-id="element-171">
                  <Mail className="h-4 w-4 text-white/40 flex-shrink-0" data-id="element-172" />
                  <span className="text-white/60 text-sm" data-id="element-173">
                    info@umcf.org.ua
                  </span>
                </li>
              </ul>
              <div className="flex space-x-4" data-id="element-174">
                <a href="#" className="p-2 bg-white/5 rounded-md hover:bg-white/10 transition-colors" data-id="element-175">
                  <Facebook className="h-4 w-4 text-white/80" data-id="element-176" />
                </a>
                <a href="#" className="p-2 bg-white/5 rounded-md hover:bg-white/10 transition-colors" data-id="element-177">
                  <Instagram className="h-4 w-4 text-white/80" data-id="element-178" />
                </a>
                <a href="#" className="p-2 bg-white/5 rounded-md hover:bg-white/10 transition-colors" data-id="element-179">
                  <Youtube className="h-4 w-4 text-white/80" data-id="element-180" />
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center" data-id="element-181">
            <p className="text-white/40 text-xs" data-id="element-182">
              © {new Date().getFullYear()} ФАіСУ. Всі права захищено.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-183">
              <a href="#" className="text-white/40 hover:text-white text-xs" data-id="element-184">
                Політика конфіденційності
              </a>
              <a href="#" className="text-white/40 hover:text-white text-xs" data-id="element-185">
                Умови використання
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}